export const widgetPaths = {
  fullWidget: {
    absolute: '/:clientId/widgets/:widgetId',
  },
  updateWidget: {
    absolute: '/:clientId/widgets/:widgetId/edit',
  },
  createWidget: {
    absolute: '/:clientId/widgets/create/:dashboardId/:widgetType',
  },
} as const;
